module.exports = __webpack_public_path__ + "static/media/Coming_Soon.2488a544.png";